import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import styles from './PreviewPage.scss';

import { Notes, NoteContent } from '../../constants/actionTypes';
import { getNotebooks } from '../../actions/NotebooksAction';
import { getNotes } from '../../actions/NotesAction';
import { getNoteContent } from '../../actions/NoteContentAction';
import { getState as getNotebooksState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getNotesState } from '../../reducers/Notes/NotesReducer';
import { getState as getContentState } from '../../reducers/NoteContent/NoteContentReducer';

import withLoading from '../../HOC/withLoading';
import { MarkDownEditor } from '../../components/Editor';
import PreviewWrapper from '../../components/PreviewWrapper/PreviewWrapper';

import {
  checkNoteIsInSeq,
  checkContent,
  checkNotes,
  keyDownResult,
} from '../../utils/util';

@connect(
  state => ({
    notebooks: getNotebooksState(state),
    notes: getNotesState(state),
    notesStatus: getNotesState(state).get('status'),
    content: getContentState(state),
  }),
  dispatch => ({
    getNotebooks: (isForce = false) => dispatch(getNotebooks(isForce)),
    getNotes: (nbId, isForce = false) => dispatch(getNotes(nbId, isForce)),
    getNoteContent: (noteId, isForce = false) => dispatch(getNoteContent(noteId, isForce)),
  }),
)
@withLoading((props) => {
  const { notebooks, content, notesStatus, match } = props;
  const { params: { nbId, noteId } } = match;
  const notes = notebooks.getIn(['entities', nbId, 'notes']);
  // 从后端拿到notes且notes长度为0时，移除loading
  if (notes && notes.size === 0) {
    return false;
  }
  if (notesStatus === Notes.GET_NOTES_FAIL) {
    return false;
  }
  const status = content.getIn(['entities', noteId, 'status']);
  // 当获取失败或已经成功拿到文章时，移除loading
  // eslint-disable-next-line max-len
  return !((checkNotes(props) && checkContent(props)) || status === NoteContent.GET_NOTE_CONTENT_FAIL);
})({ tip: 'global.content-loading', hasMask: true })
export default class PreviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { match } = this.props;
    const { params: { noteId, nbId } } = match;
    this.props.getNotebooks();
    this.props.getNotes(nbId);
    this.props.getNoteContent(noteId);
  }

  onKeyDown = (e) => {
    const { history, match } = this.props;
    const { params: { nbId, noteId } } = match;
    const result = keyDownResult(e);
    // 按下ESC
    if (result.esc) {
      history.push(`/notebooks/${nbId}/notes/${noteId}`);
      e.preventDefault();
    }
  };

  getTitle = () => {
    const { notes, match } = this.props;
    const { params: { noteId } } = match;
    return notes.getIn(['entities', noteId, 'title'], '');
  };

  getContent = () => {
    const { content, match } = this.props;
    const { params: { noteId } } = match;
    return content.getIn(['entities', noteId, 'content']);
  };

  render() {
    const hasContent = checkContent(this.props);
    const hasNotes = checkNotes(this.props);
    const isValid = checkNoteIsInSeq(this.props);

    if (hasNotes && hasContent && isValid) {
      return (
        <Row className={styles['page']} tabIndex="-1" onKeyDown={this.onKeyDown}>
          <Col span={12} className={styles['editor']}>
            <MarkDownEditor isPreviewMode {...this.props}/>
          </Col>
          <Col span={12} className={`${styles['preview']} result-html`}>
            <h1 className={styles['title']}>{this.getTitle()}</h1>
            <PreviewWrapper
              content={this.getContent()}
            />
          </Col>
        </Row>
      );
    }
    return (
      <div className={styles['no-notes']}>
        <span>简 书</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PreviewPage/PreviewPage.js